__turbopack_context__.v({
  "linkedAssetItem": "LinkedAssetsWarning-module__Vzag9q__linkedAssetItem",
  "linkedAssetList": "LinkedAssetsWarning-module__Vzag9q__linkedAssetList",
  "warningContainer": "LinkedAssetsWarning-module__Vzag9q__warningContainer",
});
